import ownKeys from './ownKeys';
export default function hasGeneratorInterface(handler) {
  var keys = ownKeys(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/hasGeneratorInterface.js
// module id = 2226
// module chunks = 2